import { createApp } from "vue";
import RelatedArticles from "./RelatedArticles.vue";

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector("#relatedArticles")) {
    return
  }

  const relatedArticles = createApp({
    components: { RelatedArticles }
  })

  relatedArticles.mount("#relatedArticles")
})
